<script setup lang="ts">
import EntryCard from './EntryCard.vue';
</script>

<template>
	<div class="entry">
		<div class="container:xl">
			<EntryCard>
				<slot />
			</EntryCard>
		</div>
	</div>
</template>
